"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var DeckMenuWrapper = function DeckMenuWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _this.resetCard = function () {
        _state.DeckUI.onSoftReset();
        if (_state.DeckUI.exerciseCard) {
          _state.ExerciseUI.resetExerciseAnswers();
        }
      };
      _this.onOpenMenu = function () {
        _state.DeckUI.createEvent('deck menu - open');
      };
      _this.onRestartCard = function () {
        _state.DeckUI.createEvent('deck menu - click restart card');
        _this.resetCard();
      };
      _this.onNextCard = function () {
        _state.DeckUI.createEvent('deck menu - click next card');
        _state.DeckUI.skipAnimationNextCard();
      };
      _this.onPreviousCard = function () {
        _state.DeckUI.createEvent('deck menu - click previous card');
        _state.DeckUI.skipAnimationGotoLastCard();
      };
      _this.onDeckGrammar = function () {
        _state.DeckUI.createEvent('deck menu - click deck grammar');
        _state.DeckUI.gotoDeckGrammar();
      };
      _this.onRestartDeck = function () {
        _state.DeckUI.createEvent('deck menu - click restart deck');
        _state.DeckUI.resetDeck();
      };
      _this.onShortcuts = function () {
        _state.DeckUI.createEvent('deck menu - click shortcuts');
        _state.DeckUI.gotoShortcuts();
      };
      _this.onGoToCard = function () {
        _state.DeckUI.createEvent('deck menu - click go to card');
        if (!_state.DeckUI.layout.isNative) {
          _state.DeckUI.gotoCardList();
        }
      };
      _this.onSettings = function () {
        _state.DeckUI.createEvent('deck menu - click settings');
        if (!_state.DeckUI.layout.isNative) {
          _state.DeckUI.gotoDeckSettings();
        }
      };
      _this.onMobileSettings = function () {
        _state.DeckUI.createEvent('deck menu - click mobile settings');
      };
      _this.onReportBug = function () {
        _state.DeckUI.createEvent('deck menu - click report bug');
        if (!_state.DeckUI.layout.isNative) {
          _state.DeckUI.gotoReportBug();
        }
      };
      _this.onReportTranslation = function () {
        var _DeckUI$deck;
        _state.DeckUI.createEvent("deck menu - click ".concat((_DeckUI$deck = _state.DeckUI.deck) !== null && _DeckUI$deck !== void 0 && _DeckUI$deck.synonymDeck ? 'report synonym' : 'report translation'));
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "disableResetCard",
      get: function get() {
        var _DeckUI$currentCardSt;
        return !_state.DeckUI.currentCardRevealed && !((_DeckUI$currentCardSt = _state.DeckUI.currentCardState) !== null && _DeckUI$currentCardSt !== void 0 && _DeckUI$currentCardSt.hasShownHint) || _state.DeckUI.exerciseCard && !_state.ExerciseUI.revealed;
      }
    }, {
      key: "disableReport",
      get: function get() {
        return _state.DeckUI.isLastCard || !_state.DeckUI.currentCard || !_state.DeckUI.currentCardRevealed;
      }
    }, {
      key: "reportMenuTitle",
      get: function get() {
        var _DeckUI$deck2;
        return (_DeckUI$deck2 = _state.DeckUI.deck) !== null && _DeckUI$deck2 !== void 0 && _DeckUI$deck2.synonymDeck ? 'Report Synonym' : 'Report Translation';
      }
    }, {
      key: "synonymAssociation",
      get: function get() {
        var _DeckUI$deck3, _DeckUI$currentCard, _DeckUI$currentWord;
        if (!((_DeckUI$deck3 = _state.DeckUI.deck) !== null && _DeckUI$deck3 !== void 0 && _DeckUI$deck3.synonymDeck) || !((_DeckUI$currentCard = _state.DeckUI.currentCard) !== null && _DeckUI$currentCard !== void 0 && _DeckUI$currentCard.synonymAssociationId)) {
          return null;
        }
        return ((_DeckUI$currentWord = _state.DeckUI.currentWord) === null || _DeckUI$currentWord === void 0 || (_DeckUI$currentWord = _DeckUI$currentWord.synonymAssociations) === null || _DeckUI$currentWord === void 0 ? void 0 : _DeckUI$currentWord.find(function (item) {
          return item.id === _state.DeckUI.currentCard.synonymAssociationId;
        })) || null;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          disableResetCard: this.disableResetCard,
          disableReport: this.disableReport,
          reportMenuTitle: this.reportMenuTitle,
          synonymAssociation: this.synonymAssociation,
          resetCard: this.resetCard,
          onOpenMenu: this.onOpenMenu,
          onRestartCard: this.onRestartCard,
          onNextCard: this.onNextCard,
          onPreviousCard: this.onPreviousCard,
          onDeckGrammar: this.onDeckGrammar,
          onRestartDeck: this.onRestartDeck,
          onShortcuts: this.onShortcuts,
          onGoToCard: this.onGoToCard,
          onSettings: this.onSettings,
          onMobileSettings: this.onMobileSettings,
          onReportBug: this.onReportBug,
          onReportTranslation: this.onReportTranslation
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "disableResetCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableResetCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableReport", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableReport"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reportMenuTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reportMenuTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymAssociation"), _class2.prototype), _class2)) || _class;
};
DeckMenuWrapper.displayName = 'DeckMenuWrapper';
var _default = exports["default"] = DeckMenuWrapper;